module.exports = __webpack_public_path__ + "img/5.84d2e531.png";